import { z } from 'zod';

import { schemaErrorProcessingFailed, schemaErrorUnprocessable } from './Errors';
import { schemaEuropaceBasicCreatedResponse } from './EuropaceBasicCreatedResponse.schema';
import { schemaEuropaceBasicResponse } from './EuropaceBasicResponse.schema';

// this is used in the LoanRequest_EuropaceProcessUpdateApplicantAdded and LoanRequest_EuropaceProcessUpdated events so we can only add optional properties
export const schemaUpdateProcess = z.object({
    data: z.record(z.union([schemaEuropaceBasicCreatedResponse, schemaEuropaceBasicResponse])).optional(),
    errors: z.array(z.union([schemaErrorProcessingFailed, schemaErrorUnprocessable])).optional(),
});

export type SchemaEuropaceUpdateProcess = z.infer<typeof schemaUpdateProcess>;

// this is necessary because we don't want to use error responses as success responses since success responses should only contain the data object
// also this does not break the type safety since the errors array is optional
export const schemaUpdateProcessSuccessResponse = schemaUpdateProcess
    .omit({ errors: true })
    .merge(z.object({ errors: z.array(z.never()).optional() }));

export type SchemaEuropaceUpdateProcessSuccessResponse = z.infer<typeof schemaUpdateProcessSuccessResponse>;
